$(function () {
	$('[data-toggle="popover"]').popover()
});

$(function () {
	$('[data-toggle="tooltip"]').tooltip()
})